import { render, staticRenderFns } from "./DashboardHeroCarousel.vue?vue&type=template&id=22c63ff9&scoped=true"
import script from "./DashboardHeroCarousel.vue?vue&type=script&lang=js"
export * from "./DashboardHeroCarousel.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeroCarousel.vue?vue&type=style&index=0&id=22c63ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c63ff9",
  null
  
)

export default component.exports